import CONST from "./Constant";

const INITIAL_STATE = {
    list:[],
    selected:{},
    error: [],
    code: "",
    config:{
        from:0,
        to:0,
        lastPage:0,
        rowCount:0,
        pagination:{
            page:0,
            pageSize:10,
        },
        filters:{
            keyword:'',
            sort_by:'created_at',
            sort_dir:'desc',
        }
    },
};

const Reducer = (state = INITIAL_STATE, action) => {

    switch (action.type){
        case CONST.CLEAR_DATA:
            return {
                ...state,
                list: [],
                selected: {},
            }
        case CONST.SET_CONFIG:
            return {
                ...state,
                config: {
                    ...state.config,
                    ...action.payload
                },
            };
        case CONST.RESET_ALL:
            return INITIAL_STATE;
        case CONST.SET_SELECTED_USER:
            return {
                ...state,
                selected: state.list.find(item => item.id === action.payload) || {},
            }
        case CONST.FETCH_USER_SUCCESS:
            return {
                ...state,
                selected: action.payload.data,
                error: [],
                message: ["User loaded successfully"],
                code:action.payload.status,
            }
        case CONST.FETCH_USERS_SUCCESS:
            // Check if response has pagination data (paginated response has data.data, non-paginated has direct data array)
            const hasPagination = action.payload.data && action.payload.data.data && Array.isArray(action.payload.data.data);
            
            return hasPagination ? {
                ...state,
                list: action.payload.data.data,
                config:  {
                    ...state.config,
                    from:action.payload.data.from,
                    to:action.payload.data.to,
                    lastPage:action.payload.data.last_page,
                    total:action.payload.data.total,
                    pagination:{
                        ...state.config.pagination,
                        page:action.payload.data.current_page - 1,
                        pageSize:action.payload.data.per_page,
                    },
                },
                error: [],
                code:action.payload.status,
                message: ["Users loaded successfully"],
            } : {
                ...state,
                list: Array.isArray(action.payload.data) ? action.payload.data : [],
                error: [],
                code:action.payload.status,
                message: ["Users loaded successfully"],
            }
        case CONST.REGISTER_USER_SUCCESS:
            return {
                ...state,
                selected: action.payload?.data?.user,
                error: [],
                message: ["User registered successfully! Check your inbox for verification email"],
                code:action.payload.status
            }
        case CONST.ADD_USER_TO_DEPARTMENT_SUCCESS:
        case CONST.ADD_USER_SUCCESS:
            return {
                ...state,
                list:[...state.list,action.payload.data],
                selected: {},
                error: [],
                message: ["User added successfully"],
                code:action.payload.status,
            }
        case CONST.UPDATE_USER_SUCCESS:
            const indexU = state.list.findIndex(user => user.id === action.payload.data.id);
            return {
                ...state,
                list: [...state.list.slice(0, indexU), action.payload.data, ...state.list.slice(indexU + 1)],
                selected: action.payload.data,
                error: [],
                message: ["User updated successfully"],
                code:action.payload.status,
            }
        case CONST.REMOVE_USER_FROM_DEPARTMENT_SUCCESS:
        case CONST.DELETE_USER_SUCCESS:
            return {
                ...state,
                list:state.list.filter(item => item.id !== action.payload.data),
                selected: {},
                error: [],
                message: ["User deleted successfully"],
                code:action.payload.status,
            }
        case CONST.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                selected: action.payload.data,
                error: [],
                message: ["Password changed successfully"],
                code:action.payload.status,
            }
        case CONST.FETCH_USERS_FAILED:
        case CONST.FETCH_COLLEAGUE_FAILED:
        case CONST.REGISTER_USER_FAILED:
        case CONST.CAPTURE_LEAD_FAILED:
        case CONST.ADD_USER_FAILED:
        case CONST.UPDATE_USER_FAILED:
        case CONST.DELETE_USER_FAILED:
        case CONST.ADD_USER_TO_DEPARTMENT_FAILED:
        case CONST.REMOVE_USER_FROM_DEPARTMENT_FAILED:
        case CONST.FETCH_USER_FAILED:
        case CONST.CHANGE_PASSWORD_FAILED:
            return {
                ...state,
                error: action.payload.data.errors,
                message: action.payload.data.message,
                code:action.payload.status,
            }
        default:
            return state;
    }
}

export default Reducer ;